export default __webpack_public_path__ + "static/media/robertapazulini.6fb9b980.jpg";